// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__2IGdC","footer":"ModalInfo_footer__1RaJA"};